import { assert, Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";

export default {
  name: "TestRomo",
};

export const testRomoRundbogenKlickAufSelbeFüllung: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.inspiration = APP.richMetadata.findAuswahlwert("Inspiration Longlife Romo")?.Inspiration[0];
  agt.update3d();
  const s = agt.segmente[0];
  const element = s.addPart(
    agt.createElementFromJson({
      snap: -1,
      x: 2,
      breite: 1.8,
      höhe: 1.96,
      füllungAuswahlwert: "LONGLIFE ROMO Weiss",
      massAuswahlwert: "Longlife_180x180_Rundbogen_V-Gitter",
    })
  );
  agt.update3d();
  const { Füllung } = agt.auswahlAccessoren;
  Füllung.setter(element.füllungAuswahlwert);
  agt.update3d();
  assert.equals("Longlife_180x180_Rundbogen_V-Gitter", element.massAuswahlwert.Key);
};
